import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import DocRenderer from './DocRenderer';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import images from '../constants/image.js';
import { Navbar } from './Navbar.jsx';

function FilesPrev() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, resumeFile, jobDescriptionFile, jobDescriptionText } = location.state || {};

  const handleContinue = () => {
    const completedSteps = JSON.parse(localStorage.getItem('completedSteps')) || [];
    if (!completedSteps.includes('filesPreview')) {
      completedSteps.push('filesPreview');
      localStorage.setItem('completedSteps', JSON.stringify(completedSteps));
    }
    navigate('/partScore', {
      state: { data, jobDescriptionFile, jobDescriptionText, resumeFile },
    });
  };

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  // Monitor screen size changes
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
    <Navbar />
    <div className="flex flex-col bg-white min-h-screen p-4 md:p-8">
      {/* Top Buttons */}
      <div className="flex justify-between items-center mt-4 space-x-2">
        <Link to="/upload">
          <button className="btn btn-outline btn-error px-6 py-2 rounded-lg bg-black text-white  border-sky-500 hover:bg-orange-500">
            Back
          </button>
        </Link>
        <button
          className="btn btn-outline btn-success px-6 py-2 rounded-lg bg-gray-600 text-white border-sky-500 hover:bg-orange-500"
          onClick={handleContinue}
        >
          Next
        </button>
      </div>

      {/* Content Section */}
      <div className="flex flex-col lg:flex-row justify-center items-start gap-8 mt-10">
        {/* Resume Section */}
        <div className="flex flex-col items-center lg:w-1/2 w-full">
          <h6 className="text-black font-semibold text-xl sm:text-2xl lg:text-3xl mb-4">
            Preview your Resume
          </h6>
          <div className="w-full bg-white shadow-lg overflow-y-auto overflow-x-hidden rounded-lg max-h-[70vh]">
            {resumeFile ? (
              // Re-render DocRenderer when screen size changes
              <DocRenderer file={resumeFile} key={`${screenWidth}-${screenHeight}`} />
            ) : (
              <div className="text-sky-600">No resume uploaded.</div>
            )}
          </div>
        </div>

        {/* Job Description Section */}
        <div className="flex flex-col items-center lg:w-1/2 w-full">
          <h6 className="text-black font-semibold text-xl sm:text-2xl lg:text-3xl mb-4">
            Preview Job Description
          </h6>
          <div className="w-full bg-white shadow-lg overflow-y-auto overflow-x-hidden rounded-lg max-h-[70vh]">
            {jobDescriptionFile ? (
              <DocRenderer file={jobDescriptionFile} key={`${screenWidth}-${screenHeight}`} />
            ) : jobDescriptionText ? (
              <div className="text-sky-600">{jobDescriptionText}</div>
            ) : (
              <div className="text-sky-600">No job description uploaded.</div>
            )}
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default FilesPrev;
